import {Component, Input} from '@angular/core'
import { ModuleConfig } from '../../../interfaces'

@Component({
  selector: 'dmmp-container',
  templateUrl: './container.component.html'
})
export class ContainerComponent {

  @Input() data: ModuleConfig
  @Input() identifier
  @Input() defaultClass
}
